import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Ultraship_ds_get_orders_by_project_and_filtersService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { projectLookupCode?: string }): 
  Promise<{ result: { Id?: number, LookupCode?: string, OrderClassId?: number, OrderStatusId?: number, OwnerReference?: string, ProjectId?: number, VendorReference?: string, Project?: { LookupCode?: string, Name?: string }, OrderClass?: { LookupCode?: string, Name?: string }, ShipmentOrderLookups?: { OrderId?: number, ShipmentId?: number }[] }[] }> 
  {
    let url = `${environment.backendUrl}api/Ultraship/datasources/ds_get_orders_by_project_and_filters/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { projectLookupCode?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, OrderClassId?: number, OrderStatusId?: number, OwnerReference?: string, ProjectId?: number, VendorReference?: string, Project?: { LookupCode?: string, Name?: string }, OrderClass?: { LookupCode?: string, Name?: string }, ShipmentOrderLookups?: { OrderId?: number, ShipmentId?: number }[] }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Ultraship/datasources/ds_get_orders_by_project_and_filters/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { projectLookupCode?: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, OrderClassId?: number, OrderStatusId?: number, OwnerReference?: string, ProjectId?: number, VendorReference?: string, Project?: { LookupCode?: string, Name?: string }, OrderClass?: { LookupCode?: string, Name?: string }, ShipmentOrderLookups?: { OrderId?: number, ShipmentId?: number }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Ultraship/datasources/ds_get_orders_by_project_and_filters/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}
